module.exports = __webpack_public_path__ + "static/images/icon-wechat.1d98680.png";